import {useQuery} from '@tanstack/react-query'
// import { useAuthUser } from 'react-auth-kit';

import {ProductListSchemaResponse, ProductSchemaResponse} from '../domain'

import {useNavigate, useParams} from 'react-router-dom'
import {toast} from 'react-toastify'
import useRequestParams from 'src/feature/bite/hook/request'
import {useProduct} from '../hook'
import {useAuthUser} from 'react-auth-kit'
import {API} from 'src/feature/bite/domain'

export function useGetList() {
  const {auth, headers, errorMessage, signOut} = useRequestParams()
  const {listFilter, listSet} = useProduct()

  const userID = auth()?.id

  return useQuery(
    ['ProductList', listFilter],
    async () => {
      const Response = await fetch(`${API}/StoreProduct/List`, {
        method: 'POST',
        headers,
        body: JSON.stringify({
          ...listFilter,
          // storeID: '996225251718',
          userID,
          language: headers.Language,
        }),
      })

      if (Response.status === 401) {
        signOut()
      }

      const Data = await Response.json()

      const safeParse = ProductListSchemaResponse.safeParse(Data)

      if (!safeParse.success) {
        throw new Error(safeParse.error.message)
      }

      const parse = ProductListSchemaResponse.parse(Data)

      listSet(parse.response)

      return true
    },
    {
      enabled: true,
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      refetchOnReconnect: false,
      retry: false,
      onSuccess: () => {},
      onError: (error) => {
        toast.error(errorMessage, {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          progress: undefined,
          theme: 'light',
        })
      },
    }
  )
}

export function useGetDetail() {
  const router = useNavigate()
  const {auth, headers, errorMessage, signOut} = useRequestParams()
  const {detailSet, categoriesSet, familySet, visibilitySet} = useProduct()
  const {productId} = useParams()

  const userID = auth()?.id

  return useQuery(
    ['ProductDetail', productId],
    async () => {
      if (!productId) return true

      const Response = await fetch(`${API}/StoreProduct/Detail`, {
        method: 'POST',
        headers,
        body: JSON.stringify({productId, userID, language: headers.Language}),
      })

      if (Response.status === 401) {
        signOut()
      }

      const Data = await Response.json()

      const safeParse = ProductSchemaResponse.safeParse(Data)
      const parse = ProductSchemaResponse.parse(Data)

      if (!parse.response) {
        router('/error/products')
      }

      if (!safeParse.success) {
        throw new Error(safeParse.error.message)
      }

      let product = parse.response

      if (
        product?.publishDate === null ||
        product?.publishDate === '' ||
        product?.publishDate === '0001-01-01T00:00:00.000Z' ||
        product?.publishDate === '0001-01-01T00:00:00'
      ) {
        product.publishDate = new Date().toISOString()
      }

      if (
        product?.endDate === null ||
        product?.endDate === '' ||
        product?.endDate === '0001-01-01T00:00:00.000Z' ||
        product?.endDate === '0001-01-01T00:00:00'
      ) {
        product.endDate = new Date(new Date().setDate(new Date().getDate() + 1)).toISOString()
      }

      detailSet(product)

      const CategoryResponse = await fetch(`${API}/Category/List`, {
        method: 'POST',
        headers,
        body: JSON.stringify({
          userID,
          language: headers.Language,
        }),
      })

      const CategoryData = await CategoryResponse.json()

      const FamilyResponse = await fetch(`${API}/StoreProductFamily/List`, {
        method: 'POST',
        headers,
        body: JSON.stringify({
          userID,
          language: headers.Language,
        }),
      })

      const FamilyData = await FamilyResponse.json()

      const VisibilityResponse = await fetch(`${API}/Visibility/List`, {
        method: 'POST',
        headers,
        body: JSON.stringify({
          userID,
          language: headers.Language,
        }),
      })

      const VisibilityData = await VisibilityResponse.json()

      categoriesSet(CategoryData?.response?.categories || [])
      familySet(FamilyData?.response?.families || [])
      visibilitySet(VisibilityData?.response?.visibilities || [])

      return true
    },
    {
      enabled: true,
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      refetchOnReconnect: false,
      retry: false,
      onError: (error) => {
        toast.error(errorMessage, {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          progress: undefined,
          theme: 'light',
        })
      },
    }
  )
}

export function useGetDetailForNew() {
  const {auth, headers} = useRequestParams()
  const {categoriesSet, familySet, visibilitySet} = useProduct()

  const userID = auth()?.id

  return useQuery(
    ['ProductNew'],
    async () => {
      const CategoryResponse = await fetch(`${API}/Category/List`, {
        method: 'POST',
        headers,
        body: JSON.stringify({
          userID,
          language: headers.Language,
        }),
      })

      const CategoryData = await CategoryResponse.json()

      const FamilyResponse = await fetch(`${API}/StoreProductFamily/List`, {
        method: 'POST',
        headers,
        body: JSON.stringify({
          userID,
          language: headers.Language,
        }),
      })

      const FamilyData = await FamilyResponse.json()

      const VisibilityResponse = await fetch(`${API}/Visibility/List`, {
        method: 'POST',
        headers,
        body: JSON.stringify({
          userID,
          language: headers.Language,
        }),
      })

      const VisibilityData = await VisibilityResponse.json()

      categoriesSet(CategoryData?.response?.categories || [])
      familySet(FamilyData?.response?.families || [])
      visibilitySet(VisibilityData?.response?.visibilities || [])

      return true
    },
    {
      enabled: true,
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      refetchOnReconnect: false,
      retry: false,
      onError: (error) => {},
    }
  )
}
